import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select } from "@/components/ui/select";

interface Line {
  id: string;
  name: string;
}

interface UploadStepProps {
  lines: Line[];
  lineId: string;
  setLineId: (v: string) => void;
  file: File | null;
  setFile: (f: File | null) => void;
  isPending: boolean;
  onSubmit: () => void;
}

export function UploadStep({
  lines,
  lineId,
  setLineId,
  file,
  setFile,
  isPending,
  onSubmit,
}: UploadStepProps) {
  return (
    <div className="space-y-3">
      <div className="grid gap-3 md:grid-cols-2">
        <div className="space-y-1.5">
          <Label htmlFor="line">Linha (opcional)</Label>
          <Select id="line" value={lineId} onChange={(e) => setLineId(e.target.value)}>
            <option value="">— Nenhuma —</option>
            {lines.map((l) => (
              <option key={l.id} value={l.id}>
                {l.name}
              </option>
            ))}
          </Select>
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="file">Planilha ou CSV</Label>
          {/* A planilha da fábrica é `.xlsx`, e o leitor sempre soube abrir as duas — quem recusava
              era só o seletor, que não listava o arquivo que o gestor veio importar. */}
          <Input
            id="file"
            type="file"
            accept=".csv,text/csv,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            onChange={(e) => setFile(e.target.files?.[0] ?? null)}
          />
        </div>
      </div>
      <div className="flex justify-end">
        <Button onClick={onSubmit} disabled={isPending || !file}>
          {isPending ? "Enviando…" : "Enviar arquivo"}
        </Button>
      </div>
    </div>
  );
}
